/**
 * pt-BR label helpers for training-center domain values shared across the
 * "Meus Treinos" and "Meus Planos" screens. All maps fall back to the raw
 * value so an unexpected backend enum never renders blank.
 */

import { formatTimeFromMinutes } from '@meiuca/web-foundation'

const LEVEL_LABELS: Record<string, string> = {
  beginner: 'Iniciante',
  'lower-intermediate': 'Intermediário baixo',
  intermediate: 'Intermediário',
  'upper-intermediate': 'Intermediário avançado',
  advanced: 'Avançado'
}

export function formatLevel(level?: string | null): string | null {
  if (!level) return null
  return LEVEL_LABELS[level] ?? level
}

/** "08:00 – 09:00" from minutes-from-midnight bounds. */
export function formatTimeRange(startTimeMin: number, endTimeMin: number): string {
  return `${formatTimeFromMinutes(startTimeMin)} – ${formatTimeFromMinutes(endTimeMin)}`
}

const PIX_KEY_TYPE_LABELS: Record<string, string> = {
  cpf: 'CPF',
  cnpj: 'CNPJ',
  email: 'E-mail',
  phone: 'Telefone',
  random: 'Chave aleatória'
}

export function formatPixKeyType(type?: string | null): string | null {
  if (!type) return null
  return PIX_KEY_TYPE_LABELS[type] ?? type
}
